/* ModuleCompletionChart auto-generated by npm run generator */
import { Line } from "@nivo/line"
import { clampNumber, Client, UserStatus } from "@qlarity/common"
import ChartCard from "components/atoms/ChartCard"
import { observer } from "mobx-react"
import React, { CSSProperties } from "react"
import Store from "store/Store"
import { defaultTheme } from "style"
import { defaultNivo } from "style/nivoTheme"

interface ModuleCompletionChartProps {
    className?: string
    style?: CSSProperties
    children?: React.ReactNode
    clients: Client[] | undefined
}

const ModuleCompletionChart: React.FC<ModuleCompletionChartProps> = ({ clients }) => {
    const preparedData = React.useMemo(() => {
        const data = Store.clientStore.modules?.map((mod) => {
            const modCompletions = clients
                ?.filter((client) => client.status === UserStatus.ACTIVE)
                .reduce(
                    (total: { x: string; y: number }, client) => {
                        total.y = client.progress?.[mod.id]?.practiceCompleted ? total.y + 1 : total.y

                        return total
                    },
                    { x: mod.moduleName.split(".")[0], y: 0 }
                )
            return modCompletions ?? { x: "", y: 0 }
        })

        const max = data?.reduce((y, curr) => (y >= curr.y ? y : curr.y), 1)

        return [{ id: "mods", max, data: data || [{}] }]
    }, [clients])

    if (!clients) {
        return null
    }
    const numTicks = clampNumber(preparedData[0].max ?? 1, 1, 5)

    return (
        <ChartCard title={`Module Completion: (by Active User)`} subtitle="Module Number">
            <Line
                theme={defaultNivo}
                width={600}
                height={300}
                colors={defaultTheme.palette.info.main}
                data={preparedData}
                axisLeft={{ tickValues: numTicks, legend: "Active Users", legendOffset: -30, legendPosition: "middle" }}
                gridYValues={numTicks}
                yScale={{ type: "linear", min: 0, max: clients.filter((client) => client.status === UserStatus.ACTIVE).length }}
                margin={{ bottom: 40, top: 32, left: 40, right: 40 }}
            />
        </ChartCard>
    )
}

export default observer(ModuleCompletionChart)
